// extracted by mini-css-extract-plugin
module.exports = {"app-font-size":"16","breakpoint":"breakpoint","number-lines":"number-lines","menuItem":"Tv1VUZ","activeMenuItem":"FoMPI6","title":"UePtfV","activeTitle":"_3sVoIx"};